import { Box, Button, MenuItem, Paper, Select, Stack, TextField, Typography } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IFreight } from '~/src/repositories/FreightRepository/models/Freight'
import { useForm } from '~/src/components/pages/SettingFreightDetail/components/FreightSettingsForm/useForm'

interface IFreightSettingsFormProps {
  freight: IFreight
  onSubmit: (values: IFreight) => void
  onDelete: () => void
}

export const FreightSettingsForm: React.FC<IFreightSettingsFormProps> = ({
  freight,
  onSubmit,
  onDelete,
}): JSX.Element => {
  const { t } = useTranslation()
  const { formValue, setFormValue, validation } = useForm(freight)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (validation()) {
      onSubmit(formValue)
    }
  }

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column' }}>
      <form action="" onSubmit={handleSubmit}>
        <Box sx={{ padding: 4, borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
          <Stack direction={'row'} alignItems={'center'} mb={'18px'} spacing={'20px'}>
            <Box
              sx={{
                width: '120px',
                height: '42px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Typography color={'#000000'} fontSize={16} fontWeight={400}>
                {t('freight.departurePort')}
              </Typography>
            </Box>
            <Select
              value={formValue?.departure.country.name}
              onChange={(e) =>
                setFormValue({
                  ...formValue,
                  departure: {
                    ...formValue.departure,
                    country: {
                      ...formValue.departure.country,
                      name: e.target.value,
                    },
                  },
                })
              }
              inputProps={{ 'aria-label': 'Without label' }}
              sx={{
                width: '433px',
                height: '40px',
                fontSize: 16,
                fontWeight: 400,
                color: '#000000',
              }}
            >
              <MenuItem value={formValue?.departure.country.name}>
                {formValue?.departure.country.name}
              </MenuItem>
            </Select>
          </Stack>
          <Stack direction={'row'} alignItems={'center'} mb={'18px'} spacing={'20px'}>
            <Box
              sx={{
                width: '120px',
                height: '42px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Typography color={'#000000'} fontSize={16} fontWeight={400}>
                {t('freight.final_destination')}
              </Typography>
            </Box>
            <Select
              value={formValue?.arrival.country.name}
              onChange={(e) =>
                setFormValue({
                  ...formValue,
                  arrival: {
                    ...formValue.arrival,
                    country: {
                      ...formValue.arrival.country,
                      name: e.target.value,
                    },
                  },
                })
              }
              inputProps={{ 'aria-label': 'Without label' }}
              sx={{
                width: '433px',
                height: '40px',
                fontSize: 16,
                fontWeight: 400,
                color: '#000000',
              }}
            >
              <MenuItem value={formValue?.arrival.country.name}>
                {formValue?.arrival.country.name}
              </MenuItem>
            </Select>
          </Stack>
          <Stack direction={'row'} alignItems={'center'} mb={'18px'} spacing={'20px'}>
            <Box
              sx={{
                width: '120px',
                height: '42px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Typography color={'#000000'} fontSize={16} fontWeight={400}>
                20ft
              </Typography>
            </Box>
            <TextField
              value={formValue?.estimate20ft}
              onChange={(e) =>
                setFormValue({
                  ...formValue,
                  estimate20ft: +e.target.value,
                })
              }
              sx={{ width: '433px', letterSpacing: 0.15 }}
              size={'small'}
            />
          </Stack>
          <Stack direction={'row'} alignItems={'center'} mb={'18px'} spacing={'20px'}>
            <Box
              sx={{
                width: '120px',
                height: '42px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Typography color={'#000000'} fontSize={16} fontWeight={400}>
                40ft
              </Typography>
            </Box>
            <TextField
              value={formValue?.estimate40ft}
              onChange={(e) =>
                setFormValue({
                  ...formValue,
                  estimate40ft: +e.target.value,
                })
              }
              sx={{ width: 433, letterSpacing: 0.15 }}
              size={'small'}
            />
          </Stack>
          <Stack direction={'row'} alignItems={'center'} mb={'18px'} spacing={'20px'}>
            <Box
              sx={{
                width: '120px',
                height: '42px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Typography color={'#000000'} fontSize={16} fontWeight={400}>
                {t('freight.estimatedDate')}
              </Typography>
            </Box>
            <TextField
              value={formValue?.estimatedAt}
              onChange={(e) => setFormValue({ ...formValue, estimatedAt: e.target.value })}
              sx={{ width: '433px', letterSpacing: 0.15 }}
              size={'small'}
            />
          </Stack>
        </Box>
        <Stack
          direction={'row'}
          justifyContent={'flex-end'}
          sx={{
            padding: 2,
          }}
          alignItems={'center'}
        >
          <Button
            onClick={onDelete}
            sx={{
              mr: '32px',
              fontSize: 15,
              fontWeight: 500,
              color: '#F44336',
            }}
          >
            {t('freight.delete')}
          </Button>
          <Button
            type={'submit'}
            variant="contained"
            startIcon={<SaveIcon />}
            sx={{ background: '#3F51B5' }}
          >
            {t('freight.save')}
          </Button>
        </Stack>
      </form>
    </Paper>
  )
}
